<script>
    import { currency_formatter } from "../../globals";
    import Header from "../header.svelte"
    import ResponsiveTable from '../../utils/responsivetable3.svelte';
    import { api_host } from "../../stores.js";
    import { getToken, doFetch } from "../../utils/Fetching.js";
    import { push } from 'svelte-spa-router';
    import { onMount } from "svelte";
    import { init_data } from '../../init.js';
    import { coupons_store } from '../../stores.js';
    import { formatDate, sort_functions } from "../../utils/format.js";
    import Swal from "sweetalert2";
    import { toast_message } from '../../utils/toast_message.js';


    const { auth_type, auth_token, domain_code } = getToken();

    onMount(() => {
        init_data('coupons');
    });

    let is_busy = false;
    let coupons = [];

    coupons_store.subscribe(value => {
        console.log(value);
        let _coupons = [];
        for (let i = 0; i < value.length; i ++) {
            const coupon = value[i];
            _coupons.push({
                "id": coupon.id,
                "c": coupon.code,
                "v": coupon.value_type.includes('Maximum Amount') ? currency_formatter.format(coupon.value) : `${coupon.value.toFixed(2)}%`,
                "vf": formatDate(coupon.from_date),
                "dt": formatDate(coupon.to_date),
                "coupon_used": coupon.coupon_used
            });
        }
        coupons = _coupons;
    })

    let table_header_config = [
        {'t': 'Code', 'fm': 'c', 'a': true},
        {'t': 'Value', 'fm': 'v', 'a': true},
        {'t': 'Expiry Date', 'fm': 'dt', 'a': true},
        {'t': 'Coupon Used', 'fm': 'coupon_used', 'a': true}
    ];

    let action_items = [
        {"id": "show", "i": "fas fa-eye", "s": "color: #1c54b2;", "f": (id) => {push("#/Coupon_Review?cid=" + id); }},
        {"id": "delete", "i": "fas fa-trash-alt", "s": "color: #ab003c;", "f": (id) => {
            Swal.fire({
                title: "Delete this coupon?",
                text: '',
                buttonsStyling: true,
                confirmButtonClass: "button",
                confirmButtonText: 'Ok',
                cancelButtonText: "Cancel",
                showCancelButton: true,
                icon: "warning"
            }).then(async (e) => {
                is_busy = true;
                if (e.isConfirmed) {
                    const res = await doFetch(
                        `${api_host}/api/coupon/delete`,
                        'POST',
                        { id },
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    console.log(res);
                    if (res.status) {
                        toast_message(true, res.msg, 2000);
                        init_data('coupons');
                    } else {
                        toast_message(false, res.msg || 'Bad request', 2000);
                    }
                }
                is_busy = false;
            });
        }},
    ];

    let date_value = '';
</script>

<Header title="Coupons" bind:is_busy={is_busy} />

<div class="contentholder">
    <div class="buttonholder">
        <button on:click={() => {push("#/Coupon_Create");}}><i class="fas fa-user-tag"></i> New Coupon</button>
    </div>

    <div class="giftcardstableholder">
        <ResponsiveTable
            table_data={coupons}
            num_per_page={100}
            show_date_range={true}
            refresh_action='coupons'
            date_filter_param='dt'
            sort_functions={sort_functions}
            bind:table_header_config={table_header_config}
            bind:date_value={date_value}
            bind:total_items={coupons.length}
            bind:action_items={action_items}
        />
    </div>

    <div style="padding-top: 10px;">
        For more information on creating and using coupon codes, please visit our <a target="_blank" href="https://houseofyards.tawk.help/article/coupon-code-guide">Coupon Code Guide.</a>
    </div>
</div>


<style>
    .buttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .buttonholder button {
        max-width: 300px;
        /* width: 100%; */
        background-color: #357a38;
        color: white;
    }
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .buttonholder {
            /* max-width: 100%; */
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .buttonholder button{
            max-width: 100%;
            width: 100%;
        }
    }
</style>